<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Root',
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/initial-variables";

$primary: #0e2d46;
$button-background-color: linear-gradient(to top,#0065de,#2e7eff);
//$primary-invert: findColorInvert($primary);

@import "~bulma";
@import "~buefy/src/scss/buefy";

.app {
  width: 100%;
  height: 100%;
}
</style>
